import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { CreateSiteService } from './create-site-service';
import { CreateSiteComponent } from './create-site.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [AppMaterialModule, FormsModule, CommonModule, NgxMaskModule.forRoot(), FlexLayoutModule],
    exports: [CreateSiteComponent],
    declarations: [CreateSiteComponent],
    providers: [CreateSiteService]
})
export class CreateSiteModule {}
